import { GetStaticProps } from 'next';
import Layout from 'layouts/master-layout';
import HeadlineBanner from 'components/headline-banner';
import Script from 'next/script';
import { getCookiePolicy } from 'data/contentful-api';
import RichText from '@madebyconnor/rich-text-to-jsx';

type CookiePolicyPageProps = {
  title: string;
  subtitle: string;
  text: JSON;
};

const CookiePolicyPage: React.FC<CookiePolicyPageProps> = ({ title, subtitle, text }) => {
  return (
    <>
      <Layout breadcrumb={[]} title={title} description={subtitle} mainClassName="cookie-policy-page">
        <HeadlineBanner wide title={title} subtitle={subtitle} />
        <div className="outer-padding">
          <div className="cookie-policy fixed-small-width">
            <Script
              src="https://consent.cookiebot.com/6541fa91-38a8-4ef9-80da-41ca1babdb74/cd.js"
              type="text/javascript"
              onLoad={() => {
                console.log('CookieDeclaration script loaded successfully');
              }}
              onError={() => {
                console.error('CookieDeclaration script failed to load');
              }}
            />
            <div>
              <RichText richText={text} />
            </div>
            <div id="CookieDeclaration" />
          </div>
        </div>
      </Layout>
    </>
  );
};

export const getStaticProps: GetStaticProps<CookiePolicyPageProps> = async ({ locale }) => {
  const cookiePolicy = await getCookiePolicy({ locale: 'en-US' });

  return {
    props: {
      title: cookiePolicy.title,
      subtitle: cookiePolicy.subtitle,
      text: cookiePolicy.text.json,
    },
    revalidate: 1,
  };
};

export default CookiePolicyPage;
